export default {
  greeting: 'Welcome back',
  description: 'Description',
  price_range: 'Budget',
  quoteStatus: 'Status',
  status: 'Status',
  date: 'Date',
  alliances: 'Alliances',
  quotes: 'Submisions',
  published_at: 'Publication Date',
  priority: {
    urgent: 'Urgent',
    featured: 'Featured',
  },
  job_listing_types: {
    urgent: 'Urgent',
    featured: 'Featured',
  },
  not_published: 'Not published',
  show_details: 'Show details',
  previous: 'Previous',
  next: 'Next',
  wallet: {
    title: 'My Wallet',
    credits: 'My Tokens',
    manage: 'Manage',
    latestExpenses: 'Latest Expenses',
  },
  organizationReview: {
    title: 'Your organization is under review',
    description:
      'We are currently reviewing your organization’s eligibility for our free credits program for nonprofit organizations. You can continue using your account normally during the review.',
  },
  notifications: {
    title: 'Notifications',
    descriptions: 'Description',
    view_all: 'View all my notifications',
    view_detail: 'View detail',
  },
  submissions: {
    title: 'My Submissions',
    view_all: 'View all my submissions',
    status: {
      submitted: 'Submitted',
      pending: 'Pending',
      accepted: 'Accepted',
      rejected: 'Rejected',
    },
  },
  jobs: {
    title: 'My job offers',
    view_all: 'View all my offers',
    status: {
      draft: 'Draft',
      published: 'Published',
      closed: 'Closed',
    },
  },
  projects: {
    title: 'My Recent Projects',
    view_all: 'View all my projects',
  },
  recent_projects: 'My Recent Projects',
  view_all_projects: 'View all my projects',
  my_prospects: 'My Prospects',
  view: 'View',
  to: 'to',
  my_contacts: 'My contacts',
};
